export const isLargeDisplay = () => {
  const isLargeDisplay = window.matchMedia('(min-width: 600px)').matches;
  return isLargeDisplay;
};
